import * as React from 'react';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import PageHeader from '../components/PageHeader';
import HowItWorks from '../components/HowItWorks';
import RecentProjects from '../components/RecentProjects';
import ActionForm from '../components/ActionForm';
import ActionFormSection from '../components/ActionFormSection';
import Form from '../components/forms/Form';
import FormSidebar from '../components/forms/FormSidebar';
import { graphql } from 'gatsby';
import ReactMarkdown from 'react-markdown';
import '../i18n';
import { useLocation } from '@reach/router';

const Page = ({ data }) => {
  const page = data.cms.pages[0];
  const [focusMode, setFocusMode] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    const gclid = new URL(location.href).searchParams.get('gclid') || '';
    const msclkid = new URL(location.href).searchParams.get('msclkid' || '');

    if (gclid) sessionStorage.setItem('gclid', gclid);
    if (msclkid) sessionStorage.setItem('msclkid', msclkid);
  }, [location.href]);

  return (
    <Layout pageTitle={page.title} focus={focusMode}>
      {page.headline ? (
        <PageHeader
          className={`${
            page.type.toLowerCase() === 'quote_form' ? 'pageHeaderFull' : ''
          } ${focusMode ? ' bg-secondary' : ''}`}
          heading={page.headline}
          background={page.background && !focusMode ? page.background.url : ''}
          description={
            page.type.toLowerCase() === 'quote_form' ? page.content : ''
          }
          focus={focusMode}
        >
          {page.type.toLowerCase() === 'quote_form' ? (
            <div className={!focusMode ? 'grid md-stack cols-3' : ''}>
              <Form
                type="quote_form"
                form={
                  page.sections.filter(
                    (section) =>
                      section.__typename === 'Strapi_ComponentFormImportForm',
                  )[0].form
                }
                onQuoteFormStarted={() => setFocusMode(true)}
              />
              {!focusMode ? (
                <FormSidebar
                  icon={
                    page.sections.filter(
                      (section) =>
                        section.__typename === 'Strapi_ComponentFormImportForm',
                    )[0].form?.icon.url
                  }
                  description={
                    page.sections.filter(
                      (section) =>
                        section.__typename === 'Strapi_ComponentFormImportForm',
                    )[0].form?.sidebarDescription
                  }
                />
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )}
        </PageHeader>
      ) : (
        ''
      )}

      {page.content &&
      page.type.toLowerCase() !== 'quote_form' &&
      !focusMode ? (
        <section className="page">
          <ReactMarkdown>
            {page.content.replaceAll(
              '%siteurl%',
              process.env.GATSBY_FRONTEND_DOMAIN.charAt(0).toUpperCase() +
                process.env.GATSBY_FRONTEND_DOMAIN.slice(1) || '',
            )}
          </ReactMarkdown>
        </section>
      ) : (
        ''
      )}

      {page.sections.map(
        (section, i) =>
          ({
            Strapi_ComponentFormLandingForm: section.landing ? (
              <Hero
                key={i}
                background={page.background ? page.background.url : ''}
              >
                <ActionForm
                  stacked={section.stacked}
                  landing={section.landing}
                  heading={section.heading}
                  pages={section.pages}
                  comfortList={section.comfortList}
                />
              </Hero>
            ) : !focusMode ? (
              <ActionFormSection key={i}>
                <ActionForm
                  stacked={section.stacked}
                  landing={section.landing}
                  heading={section.heading}
                  pages={section.pages}
                  comfortList={section.comfortList}
                />
              </ActionFormSection>
            ) : (
              ''
            ),
            Strapi_ComponentComfortSection: !focusMode ? (
              <HowItWorks
                key={i}
                heading={section.heading}
                description={section.description}
                actionBtn={section.button}
                actionSlug={section.page?.slug}
                steps={section.steps}
              />
            ) : (
              ''
            ),
            Strapi_ComponentComfortLatestProjects: !focusMode ? (
              <RecentProjects
                key={i}
                heading={section.heading}
                description={section.description}
              />
            ) : (
              ''
            ),
            Strapi_ComponentFormImportForm:
              page.type.toLowerCase() !== 'quote_form' ? (
                <div className="grid md-stack cols-3 page">
                  <Form type="contact" key={i} form={section.form} />
                  <FormSidebar
                    icon={section.form?.icon.url}
                    description={section.form?.sidebarDescription}
                  />
                </div>
              ) : (
                ''
              ),
          }[section.__typename]),
      )}
    </Layout>
  );
};

export const query = graphql`
  query ($id: String!) {
    cms {
      pages(where: { id: $id }) {
        title
        type
        headline
        background {
          url
        }
        content
        sections {
          ... on Strapi_ComponentFormLandingForm {
            __typename
            heading
            landing
            stacked
            pages(sort: "created_at:ASC") {
              title
              slug
              created_at
            }
            comfortList {
              icon {
                url
              }
              description
            }
            ctaAction
          }

          ... on Strapi_ComponentComfortSection {
            __typename
            heading
            description
            button
            page {
              slug
            }
            steps {
              description
              heading
              icon {
                url
              }
            }
          }
          ... on Strapi_ComponentComfortLatestProjects {
            __typename
            heading
            description
          }
          ... on Strapi_ComponentFormImportForm {
            __typename
            form {
              title
              heading
              description
              sidebarDescription
              icon {
                url
              }
              buttonNext
              buttonDone
              termsLabel
              comfort {
                description
                icon {
                  url
                }
              }
              form {
                input {
                  label
                  type
                  required
                  single
                  name
                  value
                  placeholder
                  heading
                }
                options {
                  option
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default Page;
